import { render, staticRenderFns } from "./RequestResetEmail.vue?vue&type=template&id=891320ec"
import script from "./RequestResetEmail.vue?vue&type=script&lang=js"
export * from "./RequestResetEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports